export const mapOptions = {
  // mapId: "76ad6d21487a0739",
  disableDefaultUI: true,
  clickableIcons: false,
};
